<div class="video_properties">
  <small class="debug">{{me}}</small>
  <mat-label>
    <div>
      <mat-icon style="position: relative; left: -5px; top: 7px">play_circle_outline</mat-icon>
      {{resourceName}}
    </div>
  </mat-label>
  <br/>
  @if (dynamicsInitialized) {
    <div style="padding-bottom: 100px">
      <dynamic-form [fields]="uiConfigInit" (submit)="submit($event)">
      </dynamic-form>
    </div>
  }
</div>
